module.exports = __webpack_public_path__ + "img/2.1db17ce4.png";